/* Pagination dots for the CSS scroll-snap carousels (.tt-swipe), plus the
   tap-to-play behaviour for 9:16 testimonial videos.

   The tracks themselves are pure CSS - this only mirrors scroll position into
   dots and lets a dot scroll the track. Runs once even if several sections
   include the tag. */
(function () {
  if (window.ttCarouselReady) return;
  window.ttCarouselReady = true;

  var MOBILE = '(max-width: 749px)';

  function buildDots(track) {
    var dots = track.parentNode.querySelector('[data-tt-dots]');
    if (!dots || dots.dataset.built) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    dots.dataset.built = '1';

    slides.forEach(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    function sync() {
      // The slide whose centre sits closest to the track's centre is current.
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestGap = Infinity;
      slides.forEach(function (s, i) {
        var gap = Math.abs(s.offsetLeft - track.offsetLeft + s.offsetWidth / 2 - mid);
        if (gap < bestGap) { bestGap = gap; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.setAttribute('aria-current', i === best ? 'true' : 'false');
      });
    }

    var queued = false;
    track.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(); });
    }, { passive: true });
    sync();
  }

  function initVideos(root) {
    root.querySelectorAll('[data-tt-video]').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var video = box.querySelector('video');
      var btn = box.querySelector('.tt-vplay');
      if (!video || !btn) return;
      btn.addEventListener('click', function () {
        box.classList.add('is-playing');
        video.controls = true;
        video.muted = false;
        var p = video.play();
        // Autoplay policies can reject an unmuted play; fall back to muted.
        if (p && p.catch) p.catch(function () { video.muted = true; video.play(); });
      });
      video.addEventListener('pause', function () {
        if (video.currentTime === 0) box.classList.remove('is-playing');
      });
    });
  }

  function init() {
    var mobile = window.matchMedia(MOBILE).matches;
    if (mobile) document.querySelectorAll('.tt-swipe').forEach(buildDots);
    initVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
  window.matchMedia(MOBILE).addEventListener('change', init);
})();
